(function () {
	angular
		.module('trackeye')
		.controller('RealtimeController', RealtimeController);

	RealtimeController.$inject = ["$scope", "RealtimeService", "DeviceService", "ConfigurationService", "ModalService", "$filter", "AccountService", "AppFactory", "C4ApiService", "NotificationService", "$translate"];

	function RealtimeController($scope, RealtimeService, DeviceService, ConfigurationService, ModalService, $filter, AccountService, app, api, NotificationService, $translate) {
		var mpl_cfg_rev = 3;
		// default values merged with "rapid_police" limitation
		var vm = this,
			account = AccountService.get();

		vm.is_loading = false;

		// Allowed durations for realtime mode, in seconds.
		vm.allowed_durations = [1,2,4,8,10,12].map(function(v) { 
			var dur = {};
			dur.readable = v;
			if (v === 1) {
				dur.translate = "STR_NTH_HOUR"
			} else {
				dur.translate = "STR_NTH_HOURS"
			}
			dur.value = v * 3600;
			return dur;
		});

		var positionsModal = ModalService.create('search-realtime-positions', vm);
		var addGroupModal = ModalService.create('add-realtime-group', vm);

		var config = ConfigurationService.factory('mpl-config', 'Marple configuration', {
			rev: mpl_cfg_rev,
			settings: {
				trace: 100,
				duration: 3600,
				labels: {
					visible: true,
					name: true,
					ts: true,
					speed: true
				}
			},
			groups: []
		});

		var now = new Date();
		now.setSeconds(0);
		now.setMilliseconds(0);
		vm.search = {
			device: undefined,
			begin_date: now,
			begin_time: now,
			end_date: now,
			end_time: undefined
		};
		
		vm.rtSearchForm;
		// vm.trace = config.get('settings.trace');
		// vm.duration = config.get('settings.duration');
		vm.groups = [];
		vm.searchSelected;
		vm.shades = app.getMarpleShades();

		vm.devices = DeviceService.getRapidPoliceDevices();
		vm.selectedDevices = [];
		vm.selectableDevices = [];
		vm.searchResults = [];

		ConfigurationService.findOneByName('mpl-config')
			.then(function (mplConfig) {
				RealtimeService.copyConfiguration(mplConfig, config);
			})
			.catch(config.save)
			.finally(function() {
				vm.trace = config.get('settings.trace');
				vm.duration = config.get('settings.duration');
				vm.groups = config.get('groups');
				vm.groups.sort(function(g1, g2) {
					var name1 = g1.name.toUpperCase(),
						name2 = g2.name.toUpperCase();

					if (name1 < name2)
						return -1;
					if (name1 > name2) {
						return 1;
					}
					return 0;
				});
			});
		
		vm.openPositionsModal = function() {
			positionsModal.open();
		}
		
		vm.searchPositions = function(search) {
			var btime = search.begin_time,
				etime = search.end_time,
				bdate = search.begin_date,
				edate = search.end_date;

			bdate.setHours(btime.getHours())
			bdate.setMinutes(btime.getMinutes());
			edate.setHours(etime.getHours());
			edate.setMinutes(etime.getMinutes());

			bdate.setSeconds(0);
			bdate.setMilliseconds(0);
			edate.setSeconds(0);
			edate.setMilliseconds(0);
			
			var begin = bdate.toJSON().replace(':00.000Z','Z'),
				end = edate.toJSON().replace(':00.000Z','Z');

			api.rapidHistorical(search.device.getNodeId(), begin, end).then(function(xhr) {
				vm.searchResults = xhr.data.map(function(pos) {
					var time = parseTime(pos.time);
					return {
						time: time,
						lon: pos.gps.lon,
						lat: pos.gps.lat
					};
				});

				vm.rtSearchForm.$setValidity('empty', !!vm.searchResults.length);
			});
		}

		function parseTime(time) {
			var ymd = time.substr(0,8),
				hms = time.substr(8,6);

			return moment(ymd+"T"+hms).format(account.getDateFormat()+" HH:mm:ss");
		}

		vm.toggleAlarms = function(group) {
			vm.is_loading = true;
			group.is_loading = true;
			
			var gDevices = [];
			group.alarms_disabled = !group.alarms_disabled;

			for (var i = 0; group.devices.length > i; i++) {
				var device = DeviceService.findOne(group.devices[i]);
				gDevices.push(device);
			}

			if (!gDevices.length) {
				vm.is_loading = false;
				delete group.is_loading;

				return;
			}

			var nodeids = JSON.stringify(gDevices.map(function(d) { return d.getNodeId() }));
			RealtimeService.toggleAlarms(gDevices, group.alarms_disabled)
			.then(function() {
				if (group.alarms_disabled) {
					NotificationService.info($translate.instant('STR_REALTIME_ALL_ALARMS_DISABLED',{group: group.name}));
					api.LogINFO('realtime: All eventhandlers disabled for '+nodeids);
				} else {
					NotificationService.info($translate.instant('STR_REALTIME_ALL_ALARMS_ENABLED',{group: group.name}));
					api.LogINFO('realtime: All eventhandlers enabled for '+nodeids);
				}
				delete group.is_loading;
				config.save();
			})
			.catch(function(err) {
				var type = group.alarms_disabled ? "disable" : "enable";
				if (err == 'no-eventhandlers') {
					api.LogINFO('realtime: No eventhandlers, when attemted to '+type+': '+nodeids);
					NotificationService.warning($translate.instant('STR_REALTIME_NO_ALARMS_FOR_GROUP',{group: group.name}));
				} else {
					api.LogINFO('realtime: Could not '+type+' eventhandlers for '+nodeids)
					api.LogINFO('realtime: '+err);
				}	

				// revert boolean
				group.alarms_disabled = !group.alarms_disabled
			})
			.finally(function() {
				delete group.is_loading;
				vm.is_loading = false;
			});
		}

		vm.editGroup = function(group,i) {
			addGroupModal.open();

			addGroupModal.groups = vm.groups;
			if (!group) {
				group = {
					active: false,
					alarms_disabled: false,
					ts: "",
					name: "",
					devices: [],
					shade: []
				};
				addGroupModal.scope.isNew = true;
			} else {
				addGroupModal.scope.index = i;
			}
			addGroupModal.scope.group = group;
			renderDeviceSelectLists(group);
		}

		vm.deleteGroup = function(index) {
			var group = vm.groups.splice(index, 1).pop();
			vm.is_loading = true;
			config.save()
				.catch(function(err) {
					console.error(err);
				})
				.finally(function() {
					vm.is_loading = false;
					api.LogINFO('realtime: Deleted group `'+group.name+'`');
					addGroupModal.close();
					NotificationService.info($translate.instant('STR_REALTIME_GROUP_DELETED',{group: group.name}))
				});
		}

		vm.toggleGroup = function(group) {
			if (group.is_loading || vm.is_loading) {
				return;
			}

			var queue;

			group.active = !group.active;
			group.ts = (new Date()).toJSON();

			var duration = group.active ? config.get('settings.duration') : 0,
				nodeids = [];

			for (var i = 0; group.devices.length > i; i++) {
				var device = DeviceService.findOne(group.devices[i]);
				nodeids.push(group.devices[i]);
				queue = api.rapidmode(device, duration);
			}

			queue.then(function() {
				delete group.is_loading;
				config.save().finally(function(){
					if (group.active) {
						api.LogINFO('realtime: Group `'+group.name+'` activated. '+JSON.stringify(nodeids));
						NotificationService.success($translate.instant('STR_REALTIME_GROUP_ACTIVE',{group: group.name}))
					} else {
						api.LogINFO('realtime: Group `'+group.name+'` deactivated. '+JSON.stringify(nodeids));
						NotificationService.info($translate.instant('STR_REALTIME_GROUP_INACTIVE',{group: group.name}))
					}
					vm.is_loading = false;
				})
			});
		}

		vm.saveGroup = function(group, isNew) {
			var hasShade = !!group.shade.length,
				hasName = !!group.name.length;

			vm.groupForm.$setValidity('shade', hasShade);
			vm.groupForm.$setValidity('required', hasName);

			if (!hasShade || !hasName) {
				return;
			}

			if (isNew) {
				vm.groups.push(group)
			}

			vm.is_loading = true;

			config.save()
				.catch(function(err) {
					console.error(err);
				})
				.finally(function() {
					vm.is_loading = false;
					addGroupModal.close()

					if (isNew) {
						api.LogINFO('realtime: Group `'+group.name+'` created');
						NotificationService.info($translate.instant('STR_REALTIME_GROUP_CREATED',{group: group.name}))
					} else {
						api.LogINFO('realtime: Group `'+group.name+'` updated');
						NotificationService.info($translate.instant('STR_REALTIME_GROUP_UPDATED',{group: group.name}))
					}
				});
		}

		vm.searchText = "";

		vm.searchFilter = function(device) {
			if (!vm.searchText)
				return true;

			if (vm.searchText.length <= 1)
				return true;

			var name = device.getName() ? device.getName().toString().toLowerCase() : "",
				nodeid = device.getNodeId() ? device.getNodeId().toString().toLowerCase() : "",
				description = device.getDescription ? device.getDescription().toString().toLowerCase() : "",
				search = vm.searchText.toLowerCase();

			return (
				(name.indexOf(search) !== -1) || 
				(nodeid.indexOf(search) !== -1) || 
				(description.indexOf(search) !== -1)
			);
		}

		vm.saveRealtimeConf = function() {
			config.set('settings', {
				trace: Math.abs(vm.trace),
				duration: vm.duration,
				labels: config.get('settings.labels')
			});

			config.save()
				.catch(function(err) {
					console.error(err);
				})
				.finally(function() {
					vm.is_loading = false;
					api.LogINFO('realtime: Settings changed. '+JSON.stringify(config.get('settings')));
					addGroupModal.close()
				});
		}

		vm.setShade = function(group, shade) {
			group.shade = shade;
			vm.groupForm.group_shade.$setDirty();
		}

		vm.isShadeSelected = function(groupShade, shade) {
			if (!groupShade) {
				return false;
			}
			return (groupShade[0] === shade[0]) && (groupShade[1] === shade[1]);
		}

		vm.groupStatus = function(active, ts) {
			var text;

			if (!ts) {
				ts = ""
			}

			if (ts.length === 0) {
				text = 'STR_REALTIME_NOT_USED_YET';
			} else {
				if (active === true) {
					text = 'STR_REALTIME_GROUP_STARTED_AT'
				} else {
					text = 'STR_REALTIME_GROUP_STOPPED_AT'
				}
			}

			return text;
		}

		vm.getFormattedTime = function(ts) {
			if (!ts) {
				return undefined;
			}

			return $filter('amDateFormat')(moment(ts).format(), account.getDatetimeFormat());
		}

		$scope.$on('DeviceService.initialized', function () {
			vm.devices = DeviceService.getRapidPoliceDevices();
		});

		vm.getDevice = function(nodeid) {
			return DeviceService.findOne(nodeid);
		}

		vm.addDevice = function(group, device) {
			vm.groupForm.$setDirty()
			if (group.devices.indexOf(device.getNodeId()) === -1) {
				group.devices.push(device.getNodeId());
			}

			renderDeviceSelectLists(group);
		}

		vm.removeDevice = function(group, device) {
			vm.groupForm.$setDirty()
			var idx = group.devices.indexOf(device.getNodeId());
			group.devices.splice(idx, 1);
			renderDeviceSelectLists(group);
		}

		vm.removeAllDevices = function(group) {
			vm.groupForm.$setDirty()
			group.devices = [];
			renderDeviceSelectLists(group);
		}

		function renderDeviceSelectLists(group) {
			vm.selectedDevices = group.devices.map(function(nodeid) {
				return DeviceService.findOne(nodeid) || undefined;
			});

			vm.selectableDevices = vm.devices.filter(function(device) {
				return vm.selectedDevices.indexOf(device) === -1;
			});
		}
	}
})();